import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'fi-agreement-view-accepted-view',
    templateUrl: './agreement-view-accepted-view.component.html',
    styleUrls: ['./agreement-view-accepted-view.component.scss'],
    standalone: false,
})
export class AgreementViewAcceptedViewComponent implements OnInit {
    @Input() agreementUserLog;

    constructor() {}

    ngOnInit() {}
}
